import { Attachment } from "@/api/attachment";
import { ImageFullscreen } from "@/components/modal/imageFullscreen";
import { SupportedLocale } from "@/i18n";

interface ArtworkImagesProps {
  mainImage: Attachment | null;
  otherImages: Attachment[];
  locale: SupportedLocale;
}

export function ArtworkImages({
  mainImage,
  otherImages,
  locale,
}: ArtworkImagesProps) {
  const getAltText = (attachment: Attachment): string => {
    return attachment.textAlt?.[locale] || "";
  };

  return (
    <div className="w-full flex xs:flex-col md:flex-row gap-4 text-left relative">
      {otherImages.length > 0 && (
        <div className="md:max-w-20 xs:w-full flex md:flex-col xs:flex-row gap-4 md:order-1 xs:order-2 z-10 md:sticky md:top-4">
          {otherImages.map((attachment) => (
            <ImageFullscreen
              media={{
                attachments: [attachment],
                type: "artwork",
                alt: getAltText(attachment),
                width: 500,
                height: 500,
                className: "xs:max-w-20 md:w-full",
              }}
              key={attachment.id}
            />
          ))}
        </div>
      )}
      {mainImage && (
        <div
          className={`xs:ml-0 w-full md:order-2 xs:order-1 ${
            otherImages.length > 0 ? "md:w-[calc(100%-6rem)]" : ""
          }`}
        >
          <ImageFullscreen
            media={{
              attachments: [mainImage],
              type: "artwork",
              alt: getAltText(mainImage),
              width: 900,
              height: 900,
              className: "w-full object-contain",
            }}
          />
        </div>
      )}
    </div>
  );
}
